import React, { useContext, useEffect } from 'react';

import * as routes from '../routes/routes';

import { GlobalSettingsContext } from '../firebase/GlobalSettingsContext';
import { UserDataContext } from '../firebase/UserDataContext';
import { useLocation } from 'react-router';
import { ROLES } from '../components/misc/Utils';
import { useNavigate } from 'react-router-dom';
import InviteUserPage from '../pages/InviteUserPage';
import LoadingSkeleton from '../components/misc/LoadingSkeleton';

const TeamActionsRouter = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const { globalSettings } = useContext(GlobalSettingsContext)
    const { user } = useContext(UserDataContext)

    useEffect(() => {
        if (Object.keys(user).length > 0 && !user.loggedIn) {
            navigate(routes.SIGN_IN)
        }
    }, [user, navigate])
    switch (true) {
        case Object.keys(globalSettings).length === 0 || Object.keys(user).length === 0:
            return <LoadingSkeleton />
        case location.pathname.includes(routes.INVITE_TEAMMATE_PAGE):
            return <InviteUserPage />
        default:
            return <div>Unknown Route. Contact an Administrator</div>

    }
}

export default TeamActionsRouter
